<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row my-5"
		[addable]="false"
		[isImportable]="false"
	></app-nav-gestion-donnees>

	<div *ngIf="vehicule" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ vehicule.name }}, {{ vehicule.model }}</span
					>
				</div>

				<div *ngIf="isDeletable" class="">
					<a
						(click)="openConfirmDeleteModal(deleteVehicule)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="row rounded bg-light">
			<form id="detailForm" [formGroup]="detailForm" (ngSubmit)="onSubmit()">
				<div *ngIf="!isFormReadOnly" class="row mt-4">
					<div class="col-4">
						<label for="name" class="form-label fw-bold">Nom du véhicule</label>
						<input
							autocomplete="off"
							required
							type="text"
							class="form-control"
							id="name"
							name="name"
							formControlName="name"
							[ngClass]="{
								'is-invalid': name.invalid && (name.dirty || name.touched),
								'is-valid': name.dirty && name.valid
							}"
						/>
						<div
							*ngIf="name.invalid && (name.dirty || name.touched)"
							class="invalid-feedback"
						>
							<span *ngIf="name.errors?.required">Un nom est requis</span>
							<span *ngIf="name.errors?.maxlength"
								>Le nom ne doit pas dépasser
								{{ MAX_NAME_CHAR }} caractères</span
							>
							<span *ngIf="name.errors?.pattern"
								>Le format du nom n'est pas correct</span
							>
						</div>
					</div>
					<div class="col-4">
						<label for="model" class="form-label fw-bold">Modèle</label>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="model"
							name="model"
							formControlName="model"
							[ngClass]="{
								'is-invalid': model.invalid && (model.dirty || model.touched),
								'is-valid': model.dirty && model.valid
							}"
						/>
						<div
							*ngIf="model.invalid && (model.dirty || model.touched)"
							class="invalid-feedback"
						>
							<span *ngIf="model.errors?.required">Un modèle est requis</span>
							<span *ngIf="model.errors?.maxlength"
								>Le modèle ne doit pas dépasser
								{{ MAX_NAME_CHAR }} caractères</span
							>
							<span *ngIf="name.errors?.pattern"
								>Le format du modèle n'est pas correct</span
							>
						</div>
					</div>
					<div class="col-4">
						<label for="model" class="form-label fw-bold">Service</label>
						<input
							autocomplete="off"
							(keyup)="centerDepartmentsKeyUp($event.target)"
							formControlName="centerDepartment"
							[typeahead]="centerDepartments"
							typeaheadOptionField="name"
							[typeaheadItemTemplate]="itemTemplateTypeaheadCenterDepartment"
							[typeaheadMinLength]="0"
							placeholder="Saisissez un service"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadCenterDepartmentOnSelect($event)"
							[ngClass]="{
								'is-valid':
									(centerDepartment.dirty || centerDepartment.touched) &&
									centerDepartment.valid &&
									selectedCenterDepartment
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadCenterDepartment
							let-model="item"
							let-index="index"
						>
							<span>{{ model?.name }}</span>
						</ng-template>
					</div>
				</div>

				<div class="row my-4">
					<div class="col-4">
						<label for="rented" class="form-label fw-bold">En location</label>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">
							<i
								*ngIf="vehicule.rented"
								class="bi bi-check-lg"
								aria-hidden="true"
							></i>
							<i
								*ngIf="!vehicule.rented"
								class="bi bi-x-lg"
								aria-hidden="true"
							></i>
						</span>
						<div *ngIf="!isFormReadOnly" class="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								id="rented"
								formControlName="rented"
							/>
						</div>
					</div>
					<div class="col-4">
						<label for="gps" class="form-label fw-bold">GPS intégré</label>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">
							<i
								*ngIf="vehicule.gps"
								class="bi bi-check-lg"
								aria-hidden="true"
							></i>
							<i
								*ngIf="!vehicule.gps"
								class="bi bi-x-lg"
								aria-hidden="true"
							></i>
						</span>
						<div *ngIf="!isFormReadOnly" class="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								id="gps"
								formControlName="gps"
							/>
						</div>
					</div>
					<div class="col-4">
						<label for="status" class="form-label fw-bold">Status</label>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">
							{{ vehiculeStatus[vehicule.status] }}
						</span>
						<select
							*ngIf="!isFormReadOnly"
							required
							class="form-select"
							name="status"
							id="status"
							formControlName="status"
							[disabled]="isFormReadOnly"
						>
							<option
								*ngFor="let status of vehiculeStatus | keyvalue"
								[ngValue]="status.key"
								[disabled]="isFormReadOnly"
							>
								{{ status.value }}
							</option>
						</select>
					</div>
				</div>

				<div class="row my-4">
					<div class="col-4">
						<label for="travelledDistance" class="form-label fw-bold"
							>Distance parcourue</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext"
							>{{ vehicule.travelledDistance }} km</span
						>
						<div *ngIf="!isFormReadOnly" class="input-group">
							<input
								class="form-control"
								type="number"
								formControlName="travelledDistance"
								[ngClass]="{
									'is-invalid':
										travelledDistance.invalid &&
										(travelledDistance.dirty || travelledDistance.touched),
									'is-valid': travelledDistance.dirty && travelledDistance.valid
								}"
							/>
							<span class="input-group-text" id="">km</span>
						</div>
					</div>
					<div class="col-4">
						<label for="mileageCost" class="form-label fw-bold"
							>Coût kilométrique</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext"
							>{{ vehicule.mileageCost }} €</span
						>
						<div *ngIf="!isFormReadOnly" class="input-group">
							<input
								class="form-control"
								type="number"
								formControlName="mileageCost"
								[ngClass]="{
									'is-invalid':
										mileageCost.invalid &&
										(mileageCost.dirty || mileageCost.touched),
									'is-valid': mileageCost.dirty && mileageCost.valid
								}"
							/>
							<span class="input-group-text" id="">€</span>
						</div>
					</div>
					<div class="col-4" *ngIf="isFormReadOnly">
						<label for="centerDepartment" class="form-label fw-bold"
							>Service</label
						>
						<span class="form-control-plaintext">{{
							vehicule.centerDepartment.name
						}}</span>
					</div>
				</div>
			</form>
		</div>

		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(false)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!detailForm.valid || isValidateButtonClicked"
					class="btn theme-green-button"
					type="submit"
					form="detailForm"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div *ngIf="vehicule && vehicule.routes?.length >= 1" class="row my-4">
		<div class="row my-2">
			<div
				*ngFor="
					let route of vehicule.routes
						| paginate : { itemsPerPage: 4, currentPage: currentPage }
				"
				class="row pt-4 pb-3 ps-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailMission(route)"
			>
				<div class="col-3">
					<span class="align-middle">{{
						route.employee.firstName + ' ' + route.employee.lastName
					}}</span>
				</div>
				<div class="col-2">
					<span class="align-middle">{{
						route.date | date : 'dd/MM/YYYY'
					}}</span>
				</div>
				<div class="col-2">
					<span class="align-middle"
						>{{ route.missions[0].plannedStart | minutesToTime }} -
						{{
							route.missions[route.missions.length - 1].plannedEnd
								| minutesToTime
						}}
					</span>
				</div>
				<div class="col-2">
					<span class="align-middle"
						>{{ route.plannedDistance / 1000 | number : '1.2-2' }} km</span
					>
				</div>
				<div class="col-1 ms-auto hand-cursor">
					<i
						class="fs-4 bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteVehicule>
	<div class="modal-header text-center">
		<h4>Suppression du véhicule</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body">Êtes-vous sûr de vouloir supprimer le véhicule ?</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete(vehicule)"
			>Supprimer</a
		>
	</div>
</ng-template>
